<template >
    <div class="container">

    <!-- Outer Row -->
    <div class="row justify-content-center">

      <div class="col-xl-10 col-lg-12 col-md-9">

        <div class="card o-hidden border-0 shadow-lg my-5">
          <div class="card-body p-0">
            <div class="row">
              <div class="col-lg-12">
                <div class="p-5">
                  <div class="text-center">
                    <h1 class="h4 text-gray-900 mb-4">
                      <span v-if="studentId!=null && studentId!='' && studentId!='new'">Оюутны мэдээлэл засах</span>
                      <span v-else>Оюутан нэмэх</span>
                      
                    </h1>
                  </div>
                  <form class="user">
                    <div class="row">
                      <div class="col-md-6 col-sm-12 form-group">
                        <label>Оюутны нэр</label>
                        <input v-model.trim="student.name" type="text" class="form-control" id="exampleInputEmail" aria-describedby="emailHelp" placeholder="Оюутны нэр">
                      </div>
                      <div class="col-md-6 col-sm-12form-group">
                        <label>Оюутны нэр</label>
                        <input v-model.trim="student.lastname" type="text" class="form-control" id="exampleInputEmail" aria-describedby="emailHelp" placeholder="Оюутны овог">
                      </div>
                    </div>
                    <div class="form-group" v-if="student.id==null || student.id==undefined">
                      <label>Оюутны код</label>
                      <input v-model.trim="student.code" type="text" class="form-control"  placeholder="Оюутны код оруулна уу">
                    </div>
                    <div class="form-group" v-if="student.id==null || student.id==undefined">
                      <label>Регистрийн дугаар</label>
                      <input v-model.trim="student.register" type="text" class="form-control"  placeholder="Оюутны регистрийн дугаар оруулна уу">
                    </div>
                    <div class="row">
                      <div class="col form-group">
                        <label>Утасны дугаар 1</label>
                        <input v-model.trim="student.phone" type="text" class="form-control"  placeholder="Утасны дугаар 1 оруулна уу">
                      </div>
                      <div class="col form-group">
                        <label>Утасны дугаар 2</label>
                        <input v-model.trim="student.phone2" type="text" class="form-control"  placeholder="Утасны дугаар 2 оруулна уу">
                      </div>
                    </div>
                    <div class="form-group">
                      <label>Имэйл</label>
                      <input v-model.trim="student.email" type="text" class="form-control"  placeholder="Имэйл оруулна уу">
                    </div>
                    <div class="form-group">
                      <label>Гэрийн хаяг</label>
                      <textarea v-model.trim="student.address" type="text" class="form-control"  placeholder="Гэрийн хаяг оруулна уу"></textarea>
                    </div>
                    <div class="row">
                      <div class="col">
                        <div class="form-group">
                          <label for="exampleFormControlSelect1">Сургууль</label>
                          <select class="form-control" v-model="school" @change="schoolChanged">
                            <option v-for="(school, index) in schools" v-bind:key="school.id" v-bind:value="school">{{index+1}}.  {{school.data().name}}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col" v-if="school!=null">
                        <div class="form-group">
                          <label for="exampleFormControlSelect1">Тэнхим</label>
                          <select class="form-control" v-model="department" >
                            <option v-for="(dep, index) in school.departments" v-bind:key="dep.id" v-bind:value="dep">{{index+1}}.  {{dep.data().name}}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="form-group" v-if="department!=null">
                      <label for="exampleFormControlSelect1">Хөтөлбөр</label>
                      <select class="form-control" v-model="program" >
                        <option v-for="(pro, index) in department.programs" v-bind:key="pro.id" v-bind:value="pro">{{index+1}}.  {{pro.data().name}}</option>
                      </select>
                    </div>
                   
                    <!-- <div class="form-group">
                      <div class="custom-control custom-checkbox small">
                        <input type="checkbox" class="custom-control-input" id="customCheck">
                        <label class="custom-control-label" for="customCheck">Remember Me</label>
                      </div>
                    </div> -->
                    <hr/>
                    <div class="row">
                      <div class="text-center col">
                        <a class="small" href="#" @click="$router.back()">Буцах</a>
                      </div>
                      <div class="col">
                        <div @click="save" class="btn btn-primary">
                          Хадгалах
                        </div>
                      </div>
                    </div>
                    <hr>
                   
                  </form>
                  
                 
                
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>

  </div>
</template>

<script>
const fb = require('../firebaseConfig.js')
export default {
    name: "StudentAdd",
    data() {
        return {
            student: {
                name: '',
                lastname:'',
                phone:'',
                phone2:'',
                code:'',
                email:'',
                address:'',
                register:''
 
            },
            performingRequest:false,
            schools:[],
            school:null,
            department:null,
            program:null
        };
    },
    methods: {
        save() {
            this.performingRequest = true
            if(this.student!=null && this.student.name!='' && this.student.code!=''){
              if(this.student.id!=null && this.student.id!='' && this.student.id!='new'){
                this.student.modified=fb.usersCollection.doc(this.$store.getters.currentUser.uid)
                this.student.modifiedAt=new Date()
                if(this.school!=null)
                  this.student.school=this.school.ref
                if(this.department!=null)
                  this.student.department=this.department.ref
                if(this.student.program!=null)
                  this.student.program=this.program.ref
                
                fb.db.collection("students").doc(this.student.id).set(this.student)

                this.$router.back();
              }
              else{
                
                fb.db.collection("students").doc(this.student.code.toLowerCase()).get().then(doc=>{
                  if(doc.exists){
                    alert(this.student.code+" кодтой оюутан бүртгэгдсэн байна.")
                    return ;
                  }
                  else{
                    this.student.code=this.student.code.toLowerCase();
                    this.student.register=this.student.register.toLowerCase();
                    fb.db.collection("students").where("register", "==", this.student.register).get().then((sts)=>{
                      if(sts.empty==true){
                        this.student.created=fb.usersCollection.doc(this.$store.getters.currentUser.uid)
                        this.student.createdAt=new Date()
                        if(this.school!=null){
                          this.student.school=this.school.ref
                          this.school.ref.update({numberOfStudents: fb.firestore.FieldValue.increment(1)})
                        }
                        if(this.department!=null){
                          this.student.department=this.department.ref
                          this.department.ref.update({numberOfStudents: fb.firestore.FieldValue.increment(1)})
                        }
                        if(this.student.program!=null){
                          this.student.program=this.program.ref
                          this.program.ref.update({numberOfStudents: fb.firestore.FieldValue.increment(1)})
                        }
                        doc.ref.set(this.student);
                        alert("Оюутан амжилттай бүртгэгдлээ.");
                        this.$router.back();
                      }
                      else{
                        alert(this.student.register+" регистртэй оюутан бүртгэгдсэн байна");
                      }
                    });
                    
                  }
                })
              }
                
            }
        },
        setStudent(){
          this.student= {
              name: '',
              lastname:'',
              phone:'',
              phone2:'',
              code:'',
              email:'',
              address:''
          }
        },
       
        remove(index, array){
          if(array!=null && array.length>0)
            array.splice(index, 1)
        },
        _getSchools(){
          fb.db.collection("schools")
          .get()
          .then(querySnapshot=> {
              querySnapshot.forEach(schoolData=> {
                
                this._getDepartments(schoolData.id, schoolData)
                this.schools.push(schoolData)
                if(this.student.school!=null && this.student.school.path==schoolData.ref.path){
                  this.school=schoolData;
                }
              });
          })
          .catch(function(error) {
              console.log("Error getting documents: ", error);
          });
        },
        _getDepartments(schoolId, schoolData){
          schoolData.ref.collection("departments")
          .get()
          .then(querySnapshot=> {
              let deps=[]
              querySnapshot.forEach(depdata=> {
                this._getPros(depdata)
                deps.push(depdata)
                if(this.student.department!=null && this.student.department.path==depdata.ref.path){
                  this.department=depdata;
                }
              });
              schoolData.departments=deps;
          })
          .catch(function(error) {
              console.log("Error getting documents: ", error);
          });
        },
        _getPros(depdata){
          depdata.ref.collection("programs")
          .get()
          .then(querySnapshot=> {
            let pros=[]
              querySnapshot.forEach(prodata=> {
                pros.push(prodata)
                if(this.student.program!=null && this.student.program.path==prodata.ref.path){
                  this.program=prodata;
                }
              });
              depdata.programs=pros
          })
          .catch(function(error) {
              console.log("Error getting documents: ", error);
          });
        },
        schoolChanged(){
          this.department=null
          this.program=null
        },
        _getStudent(){
          if(this.studentId!=null && this.studentId!='' && this.studentId!='new'){
            fb.db.collection("students").doc(this.studentId).get().then(studentData=>{
              let object=studentData.data()
              object.id=studentData.id
              this.student=object;
            });
          }
          this._getSchools();
        }
        // depChanged(){
        //   console.log(this.department)
        //   this.programs=[]
        //   if(this.department!=null && this.department.id!=null)
        //     this._getPros("schools/"+this.school.id+"/departments/"+this.department.id+"/programs");
        // }
        
        
        
    }, 
    props: {
        studentId: { 
            required: false,
        },
    },
    created() {
        this._getStudent();     
    },
  
};
</script>

